import BasicInfo from './BasicInfo';
import JobInfo from './JobInfo';
import JoiningInfo from './JoiningInfo';
import Documents from './Documents';

export { BasicInfo, JobInfo, JoiningInfo, Documents };
